import { useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { setFilters } from '../../biens/biensSlice'

export default () => {
  const dispatch = useDispatch()
  const [searchQuery, setSearchQuery] = useState('')
  const searchInputRef = useRef(null)

  const resetSearch = () => {
    if(searchQuery) {
      dispatch(setFilters({term: ''}))
      setSearchQuery('')
    }
  }

  const handleSearch = (e) => {
    e.preventDefault()
    e.stopPropagation()
    dispatch(setFilters({term: searchQuery}))
  } 

  return (
    <div className="flex items-center justify-end">
      <div className={`flex items-center transition-all duration-300 ease-in-out overflow-hidden w-80 opacity-100 mr-2`}>
        <form onSubmit={handleSearch} className="flex items-center w-full">
          <div className="relative w-full">
            <input
              ref={searchInputRef}
              type="search"
              className="input input-bordered w-full pr-10 h-10 focus:outline-none"
              placeholder="Recherche dans vos biens"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          { searchQuery.length > 2 && (
              <button
                type="button"
                className="absolute right-12 top-1/2 transform -translate-y-1/2 text-base-content/70 rounded-full w-4 h-4 transition-colors duration-200 ease-in hover:bg-gray-200 focus:outline-none focus:bg-gray-300 dark:text-white dark:hover:bg-dark-500 dark:focus:bg-dark-450 hover:bg-gray-200"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  resetSearch()
                }}
              >
                <XMarkIcon className="w-4 h-4"/>
            </button>
          )}
            <button
              type="submit"
              className="absolute inset-y-0 right-0 z-1 h-full flex items-center px-3 btn btn-primary btn-sm"
              aria-label="Rechercher"
            >
              <MagnifyingGlassIcon className="w-4 h-4" />
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}